import { ViewEventHandler } from '../../common/viewEventHandler.js';

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
class DynamicViewOverlay extends ViewEventHandler {
}

export { DynamicViewOverlay };
